import React from 'react';
import { Layout } from '../components/Layout';
import { SEO } from '../components/SEO';
import { Mail, Shield } from 'lucide-react';
export function PrivacyPolicyPage() {
  return <Layout data-id="element-1707">
      <SEO title="Politique de Confidentialité" description="Politique de confidentialité de l'ADCC Bénin. Découvrez comment nous collectons, utilisons et protégeons vos données personnelles." keywords="politique de confidentialité, ADCC Bénin, protection données personnelles, RGPD" url="https://adcc.africa/privacy-policy" data-id="element-1708" />

      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-1709">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1710">
          <div className="flex justify-center mb-4" data-id="element-1711">
            <Shield className="w-12 h-12 text-[#1E88E5]" data-id="element-1712" />
          </div>
          <h1 className="text-4xl font-bold mb-4" data-id="element-1713">
            Politique de Confidentialité
          </h1>
          <p className="text-gray-300" data-id="element-1714">ADCC Africa</p>
        </div>
      </div>

      {/* Content */}
      <section className="py-16 bg-white" data-id="element-1715">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1716">
          <p className="text-sm text-gray-500 mb-10" data-id="element-1717">
            Dernière mise à jour : 2026
          </p>

          <p className="text-gray-700 leading-relaxed mb-10" data-id="element-1718">
            ADCC Africa (« nous », « notre », « nos ») collecte et traite les
            données personnelles soumises via les formulaires de ce site web.
          </p>

          {/* Data we collect */}
          <div className="mb-10" data-id="element-1719">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1720">
              Données collectées
            </h2>
            <ul className="space-y-2 text-gray-700" data-id="element-1721">
              <li className="flex items-start gap-2" data-id="element-1722">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1723">●</span>
                <span data-id="element-1724">Nom</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1725">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1726">●</span>
                <span data-id="element-1727">Adresse email</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1728">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1729">●</span>
                <span data-id="element-1730">Numéro de téléphone</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1731">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1732">●</span>
                <span data-id="element-1733">Contenu des messages</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1734">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1735">●</span>
                <span data-id="element-1736">Données techniques (adresse IP, navigateur)</span>
              </li>
            </ul>
          </div>

          {/* Purpose */}
          <div className="mb-10" data-id="element-1737">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1738">Finalité</h2>
            <p className="text-gray-700 mb-3" data-id="element-1739">
              Nous utilisons ces données pour :
            </p>
            <ul className="space-y-2 text-gray-700" data-id="element-1740">
              <li className="flex items-start gap-2" data-id="element-1741">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1742">●</span>
                <span data-id="element-1743">Répondre aux demandes</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1744">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1745">●</span>
                <span data-id="element-1746">Fournir les services demandés</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1747">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1748">●</span>
                <span data-id="element-1749">Gérer les relations professionnelles</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1750">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1751">●</span>
                <span data-id="element-1752">Améliorer notre site web</span>
              </li>
            </ul>
          </div>

          {/* Legal basis */}
          <div className="mb-10" data-id="element-1753">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1754">
              Base légale
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1755">
              Les données sont traitées sur la base du consentement de
              l'utilisateur et de l'intérêt légitime de l'organisation.
            </p>
          </div>

          {/* Data sharing */}
          <div className="mb-10" data-id="element-1756">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1757">
              Partage des données
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1758">
              Nous ne vendons pas de données personnelles. Les données peuvent
              être traitées par des prestataires de confiance (hébergement,
              email, analytics, outils de formulaires) uniquement à des fins
              opérationnelles.
            </p>
          </div>

          {/* Data storage */}
          <div className="mb-10" data-id="element-1759">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1760">
              Stockage des données
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1761">
              Les données sont stockées de manière sécurisée et conservées
              uniquement le temps nécessaire aux obligations professionnelles ou
              légales.
            </p>
          </div>

          {/* User rights */}
          <div className="mb-10" data-id="element-1762">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1763">
              Droits des utilisateurs
            </h2>
            <p className="text-gray-700 mb-3" data-id="element-1764">Vous pouvez demander :</p>
            <ul className="space-y-2 text-gray-700" data-id="element-1765">
              <li className="flex items-start gap-2" data-id="element-1766">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1767">●</span>
                <span data-id="element-1768">L'accès à vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1769">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1770">●</span>
                <span data-id="element-1771">La correction de vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1772">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1773">●</span>
                <span data-id="element-1774">La suppression de vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1775">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1776">●</span>
                <span data-id="element-1777">Le retrait de votre consentement</span>
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2 text-gray-700" data-id="element-1778">
              <Mail className="w-4 h-4 text-[#1E88E5]" data-id="element-1779" />
              <span data-id="element-1780">
                Contact :{' '}
                <a href="mailto:contact@adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1781">
                  contact@adcc.africa
                </a>
              </span>
            </div>
          </div>

          {/* Cookies */}
          <div className="mb-10" data-id="element-1782">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1783">Cookies</h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1784">
              Ce site web peut utiliser des cookies à des fins d'analyse et de
              fonctionnalité.
            </p>
          </div>

          {/* Contact */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1785">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1786">Contact</h2>
            <p className="text-gray-700" data-id="element-1787">ADCC Africa</p>
            <p className="text-gray-700 flex items-center gap-2 mt-2" data-id="element-1788">
              <Mail className="w-4 h-4 text-[#1E88E5]" data-id="element-1789" />
              <a href="mailto:contact@adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1790">
                contact@adcc.africa
              </a>
            </p>
            <p className="text-gray-700 mt-2" data-id="element-1791">
              Site web :{' '}
              <a href="https://www.adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1792">
                https://www.adcc.africa
              </a>
            </p>
          </div>
        </div>
      </section>
    </Layout>;
}